module.exports = __webpack_public_path__ + "bcb3c53482736261638cd23f0e5397dd.png";